// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserReviewsForm-space1-rNpLw {
	margin-bottom: 6px !important;
}

.UserReviewsForm-space2-Ml1NJ {
	margin-bottom: 12px !important;
}

.UserReviewsForm-space3-NeMQH {
	margin-bottom: 18px !important;
}

.UserReviewsForm-space4-oB4Cu {
	margin-bottom: 24px !important;
}

.UserReviewsForm-space5-OxBs5 {
	margin-bottom: 30px !important;
}

.UserReviewsForm-space6-ukCQm {
	margin-bottom: 36px !important;
}

.UserReviewsForm-space7-FThmC {
	margin-bottom: 42px !important;
}

.UserReviewsForm-space8-RAd2k {
	margin-bottom: 48px !important;
}

.UserReviewsForm-spaceTop1-t3INf {
	margin-top: 6px !important;
}

.UserReviewsForm-spaceTop2-S6sKe {
	margin-top: 12px !important;
}

.UserReviewsForm-spaceTop3-tW87Y {
	margin-top: 18px !important;
}

.UserReviewsForm-spaceTop4-TvGZt {
	margin-top: 24px !important;
}

.UserReviewsForm-spaceTop5-IBvuf {
	margin-top: 30px !important;
}

.UserReviewsForm-spaceTop6-n7Zah {
	margin-top: 36px !important;
}

.UserReviewsForm-spaceTop7-NnVNy {
	margin-top: 42px !important;
}

.UserReviewsForm-spaceTop8-Kdwba {
	margin-top: 48px !important;
}

.UserReviewsForm-noMargin-HM8fD {
	margin: 0px !important;
}

.UserReviewsForm-padding1-GyA4C {
	padding-bottom: 6px !important;
}

.UserReviewsForm-padding2-UUQCc {
	padding-bottom: 12px !important;
}

.UserReviewsForm-padding3-tVviU {
	padding-bottom: 18px !important;
}

.UserReviewsForm-padding4-IgcdJ {
	padding-bottom: 24px !important;
}

.UserReviewsForm-padding5-ORgfN {
	padding-bottom: 30px !important;
}

.UserReviewsForm-padding6-rWZT4 {
	padding-bottom: 36px !important;
}

.UserReviewsForm-padding7-XXXbX {
	padding-bottom: 42px !important;
}

.UserReviewsForm-paddingTop1-VilTj {
	padding-top: 6px !important;
}

.UserReviewsForm-paddingTop2-ySkXT {
	padding-top: 12px !important;
}

.UserReviewsForm-paddingTop3-erG36 {
	padding-top: 18px !important;
}

.UserReviewsForm-paddingTop4-eLiR8 {
	padding-top: 24px !important;
}

.UserReviewsForm-paddingTop5-HqMfy {
	padding-top: 30px !important;
}

.UserReviewsForm-paddingTop6-JDP8a {
	padding-top: 36px !important;
}

.UserReviewsForm-paddingTop7-ZbZ6Y {
	padding-top: 42px !important;
}

.UserReviewsForm-noPadding-Hd_Ky {
	padding: 0px !important;
}

.UserReviewsForm-spaceMarginBottom0-uLMXa {
	margin-bottom: 0;
}

.UserReviewsForm-textBold-vBDgU {
	font-weight: 500 !important;
}

.UserReviewsForm-textBolder-GkCYd {
	font-weight: 700 !important;
}

.UserReviewsForm-textNormal-q6Mq6 {
	font-weight: normal !important;
}

/*New Design Text Colors */

.UserReviewsForm-textDarkBlue-cdvui {
	color: rgb(20, 39, 94) !important;
}

.UserReviewsForm-textLightBlue-nR1Yk {
	color: rgb(57, 87, 106) !important;
}

.UserReviewsForm-textLightSandleGreen-jBg_e {
	color: rgb(76, 86, 41) !important;
}

.UserReviewsForm-textLightBrown-K1cJh {
	color: rgb(115, 79, 33) !important;
}

.UserReviewsForm-textMediumMaroon-fbD8W {
	color: rgb(87, 37, 51) !important;
}

.UserReviewsForm-textBrown-t80LE {
	color: rgb(160, 47, 24) !important;
}

.UserReviewsForm-textMaroon-Uvjwv {
	color: rgb(155, 49, 67) !important;
}

.UserReviewsForm-textDarkBrown-sYRPR {
	color: rgb(83, 18, 16) !important;
}

.UserReviewsForm-textMediumBrown-ov1SU {
	color: rgb(142, 28, 10) !important;
}

.UserReviewsForm-textSkyBlue-KrXCZ {
	color: rgb(37, 117, 141) !important;
}

.UserReviewsForm-textGray-FQHJi {
	color: rgb(77, 65, 51) !important;
}

.UserReviewsForm-errorMessage-QYVxj {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.UserReviewsForm-userText-bN8As {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.UserReviewsForm-panelHeader-HsCu2 {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.UserReviewsForm-exportSection-UxiLb {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.UserReviewsForm-exportSectionGridSub-llbBi {
	grid-template-columns: 50% 49% !important;
}

.UserReviewsForm-exportText-Iogag {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.UserReviewsForm-exportLinkImg-MTcrB {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.UserReviewsForm-exportImg-_YDNH {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.UserReviewsForm-linkBtn-HB6Qx {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.UserReviewsForm-table-d3XZK {
	display: table;
}

.UserReviewsForm-tableRow-FqJqX {
	display: table-row;
}

.UserReviewsForm-tableCell-wcxzn {
	display: table-cell;
	float: none;
}

.UserReviewsForm-formGroup-cjcjP {
	margin-bottom: 6px;
}

.UserReviewsForm-marginTop0-AZtMa {
	margin-top: 0;
}

.UserReviewsForm-marginBottom20-f9z_3 {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.UserReviewsForm-bannerImageBg-YJM9H {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.UserReviewsForm-bannerDelete-PSdDW {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.UserReviewsForm-exportLink-x45UE {
	padding-top: 10px;
	padding-right: 10px;
}

.UserReviewsForm-seachContent-Un2I0 {
	padding-left: 0px;
	margin-bottom: 5px;
}

.UserReviewsForm-marginBottom9-XSl99 {
	margin-bottom: 9px;
}

.UserReviewsForm-spaceTop52-ZsZf5 {
	margin-top: 52px;
}

.UserReviewsForm-profileViewInner-NQB4p {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.UserReviewsForm-profileViewMain-LngwQ {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.UserReviewsForm-profileViewlabel-o4XnO {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.UserReviewsForm-profileViewMainContent-AFtZc {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.UserReviewsForm-reviewsFormStar-uaowu {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.UserReviewsForm-reviewsFormStar-uaowu svg {
	cursor: pointer;
}

.UserReviewsForm-addLanguageText-kzaip {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.UserReviewsForm-exportSection-UxiLb {
		grid-template-columns: 100%;
	}

	.UserReviewsForm-spaceTop52-ZsZf5 {
		margin-top: 18px;
	}

	.UserReviewsForm-exportText-Iogag {
		float: none;
		margin-top: 12px;
	}

	.UserReviewsForm-exportSectionGridSub-llbBi {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.UserReviewsForm-profileViewlabel-o4XnO {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.UserReviewsForm-profileViewMainContent-AFtZc {
		width: 100%;
		text-align: center;
	}

	.UserReviewsForm-panelHeader-HsCu2 {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `UserReviewsForm-space1-rNpLw`,
	"space2": `UserReviewsForm-space2-Ml1NJ`,
	"space3": `UserReviewsForm-space3-NeMQH`,
	"space4": `UserReviewsForm-space4-oB4Cu`,
	"space5": `UserReviewsForm-space5-OxBs5`,
	"space6": `UserReviewsForm-space6-ukCQm`,
	"space7": `UserReviewsForm-space7-FThmC`,
	"space8": `UserReviewsForm-space8-RAd2k`,
	"spaceTop1": `UserReviewsForm-spaceTop1-t3INf`,
	"spaceTop2": `UserReviewsForm-spaceTop2-S6sKe`,
	"spaceTop3": `UserReviewsForm-spaceTop3-tW87Y`,
	"spaceTop4": `UserReviewsForm-spaceTop4-TvGZt`,
	"spaceTop5": `UserReviewsForm-spaceTop5-IBvuf`,
	"spaceTop6": `UserReviewsForm-spaceTop6-n7Zah`,
	"spaceTop7": `UserReviewsForm-spaceTop7-NnVNy`,
	"spaceTop8": `UserReviewsForm-spaceTop8-Kdwba`,
	"noMargin": `UserReviewsForm-noMargin-HM8fD`,
	"padding1": `UserReviewsForm-padding1-GyA4C`,
	"padding2": `UserReviewsForm-padding2-UUQCc`,
	"padding3": `UserReviewsForm-padding3-tVviU`,
	"padding4": `UserReviewsForm-padding4-IgcdJ`,
	"padding5": `UserReviewsForm-padding5-ORgfN`,
	"padding6": `UserReviewsForm-padding6-rWZT4`,
	"padding7": `UserReviewsForm-padding7-XXXbX`,
	"paddingTop1": `UserReviewsForm-paddingTop1-VilTj`,
	"paddingTop2": `UserReviewsForm-paddingTop2-ySkXT`,
	"paddingTop3": `UserReviewsForm-paddingTop3-erG36`,
	"paddingTop4": `UserReviewsForm-paddingTop4-eLiR8`,
	"paddingTop5": `UserReviewsForm-paddingTop5-HqMfy`,
	"paddingTop6": `UserReviewsForm-paddingTop6-JDP8a`,
	"paddingTop7": `UserReviewsForm-paddingTop7-ZbZ6Y`,
	"noPadding": `UserReviewsForm-noPadding-Hd_Ky`,
	"spaceMarginBottom0": `UserReviewsForm-spaceMarginBottom0-uLMXa`,
	"textBold": `UserReviewsForm-textBold-vBDgU`,
	"textBolder": `UserReviewsForm-textBolder-GkCYd`,
	"textNormal": `UserReviewsForm-textNormal-q6Mq6`,
	"textDarkBlue": `UserReviewsForm-textDarkBlue-cdvui`,
	"textLightBlue": `UserReviewsForm-textLightBlue-nR1Yk`,
	"textLightSandleGreen": `UserReviewsForm-textLightSandleGreen-jBg_e`,
	"textLightBrown": `UserReviewsForm-textLightBrown-K1cJh`,
	"textMediumMaroon": `UserReviewsForm-textMediumMaroon-fbD8W`,
	"textBrown": `UserReviewsForm-textBrown-t80LE`,
	"textMaroon": `UserReviewsForm-textMaroon-Uvjwv`,
	"textDarkBrown": `UserReviewsForm-textDarkBrown-sYRPR`,
	"textMediumBrown": `UserReviewsForm-textMediumBrown-ov1SU`,
	"textSkyBlue": `UserReviewsForm-textSkyBlue-KrXCZ`,
	"textGray": `UserReviewsForm-textGray-FQHJi`,
	"errorMessage": `UserReviewsForm-errorMessage-QYVxj`,
	"userText": `UserReviewsForm-userText-bN8As`,
	"panelHeader": `UserReviewsForm-panelHeader-HsCu2`,
	"exportSection": `UserReviewsForm-exportSection-UxiLb`,
	"exportSectionGridSub": `UserReviewsForm-exportSectionGridSub-llbBi`,
	"exportText": `UserReviewsForm-exportText-Iogag`,
	"exportLinkImg": `UserReviewsForm-exportLinkImg-MTcrB`,
	"exportImg": `UserReviewsForm-exportImg-_YDNH`,
	"linkBtn": `UserReviewsForm-linkBtn-HB6Qx`,
	"table": `UserReviewsForm-table-d3XZK`,
	"tableRow": `UserReviewsForm-tableRow-FqJqX`,
	"tableCell": `UserReviewsForm-tableCell-wcxzn`,
	"formGroup": `UserReviewsForm-formGroup-cjcjP`,
	"marginTop0": `UserReviewsForm-marginTop0-AZtMa`,
	"marginBottom20": `UserReviewsForm-marginBottom20-f9z_3`,
	"bannerImageBg": `UserReviewsForm-bannerImageBg-YJM9H`,
	"bannerDelete": `UserReviewsForm-bannerDelete-PSdDW`,
	"exportLink": `UserReviewsForm-exportLink-x45UE`,
	"seachContent": `UserReviewsForm-seachContent-Un2I0`,
	"marginBottom9": `UserReviewsForm-marginBottom9-XSl99`,
	"spaceTop52": `UserReviewsForm-spaceTop52-ZsZf5`,
	"profileViewInner": `UserReviewsForm-profileViewInner-NQB4p`,
	"profileViewMain": `UserReviewsForm-profileViewMain-LngwQ`,
	"profileViewlabel": `UserReviewsForm-profileViewlabel-o4XnO`,
	"profileViewMainContent": `UserReviewsForm-profileViewMainContent-AFtZc`,
	"reviewsFormStar": `UserReviewsForm-reviewsFormStar-uaowu`,
	"addLanguageText": `UserReviewsForm-addLanguageText-kzaip`
};
module.exports = ___CSS_LOADER_EXPORT___;
